const SECOND_IN_MS = 1000
const MINUTE_IN_MS = 60 * SECOND_IN_MS
const HOUR_IN_MS   = 60 * MINUTE_IN_MS
const DAY_IN_MS    = 24 * HOUR_IN_MS
const WEEK_IN_MS   =  7 * DAY_IN_MS
const MONTH_IN_MS  = 30 * DAY_IN_MS
const DAYS_OF_WEEK = 7
const DAYS_OF_YEAR = 365
const SECONDS_IN_HOUR = 3600

const ONE_MIN_IN_SECS  = 60
const ONE_HOUR_IN_MINS = 60
const ONE_DAY_IN_HOURS = 24
const ONE_DAY_IN_SECS  = ONE_DAY_IN_HOURS * ONE_HOUR_IN_MINS * ONE_MIN_IN_SECS

const consts = {
  SECOND_IN_MS,
  MINUTE_IN_MS,
  HOUR_IN_MS,
  DAY_IN_MS,
  WEEK_IN_MS,
  MONTH_IN_MS,
  DAYS_OF_WEEK,
  DAYS_OF_YEAR,
  SECONDS_IN_HOUR,
  ONE_MIN_IN_SECS,
  ONE_HOUR_IN_MINS,
  ONE_DAY_IN_HOURS,
  ONE_DAY_IN_SECS
}

module.exports.consts = consts

/** @type {readonly string[]} */
const MONTHS = [
  'December',
  'Január',
  'Február',
  'Március',
  'Április',
  'Május',
  'Június',
  'Július',
  'Augusztus',
  'Szeptember',
  'Október',
  'November'
]

module.exports.MONTHS = MONTHS
